import { motion } from "framer-motion";
import TypingLetters from "../TypingLetters";
import { Link } from "react-router-dom"


export default function Home() {
    // const text = "CELINE HUI";
    // const characters = text.split("");

    return (
        <motion.div
        
            initial={{
                opacity: 0,
                x: -50

            }}
            animate={{
                opacity: 1,
                x: 0,
            }}
            exit={{
                opacity: 0,
                x: 50
            }}
            transition={{
                duration: 0.3,
                ease: "backInOut"
            }}>
           
                {/* {characters.map((character, i) => (
                <motion.span
                    initial={{
                        opacity: 0
                    }}
                    animate={{
                        opacity: 1
                    }}
                    transition={{
                        duration: 0.5,
                        delay: i/10,
                        type: "spring"
                    }}
                    key={i}
                >
                    {character}
                </motion.span>
                ))} */}

                

                {/* <span className="page-title-animated"
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                    style={{ display: "inline-block", cursor: "pointer", }}
                >
                    <JumpingLetters text="Celine Hui" isHover={isHover}/>
                </span> */}
                
            

            <div className="homepage-container">

                <div className="name-container">
                    <motion.div
                        // initial={{
                        //     opacity: 0,
                        // }}
                        // animate={{
                        //     opacity: 1,
                        // }}
                        // transition={{
                        //     duration: 0.2,
                        //     delay: 1,
                        //     repeat: Infinity,
                        //     repeatDelay: 1,
                        // }}
                    
                    >
                        <TypingLetters className="sub-text" text="Computer Science Student | Artist" />
                    </motion.div>
                    <div className="name-subcontainer"
                        style={{
                            
                            position: "relative"
                        }}

                    >
                        <h1 className="name-text">CELINE HUI</h1>
                    
                        <motion.div
                            style={{
                                position: "absolute",
                                left: "55%", 
                                transform: "translateX(-55%)",    
                          
                            }}
                            initial={{
                                y: "-30%",
                                opacity: 0
                                
                            }}
                            animate={{
                                y: "-48%",
                                opacity: 1
                                
                            }}
                            transition={{
                                duration: 2,
                            }}
                        
                        >
                            <h2 className="portfolio-text">portfolio</h2>

                        </motion.div>
                    </div>
                    
                    
                </div>
            </div>

            <div className="home-links">
                <Link to="/graphicDesign">Design</Link>
                <span>|</span>
                <Link to="/codingProjects">Coding</Link>
                <span>|</span>
                <Link to="/artwork">Artwork</Link>
            </div>

        </motion.div>
    );
}

